import React from "react";
import { useEffect } from "react";
import { AboutHeroSection } from "@tennr/frontend/sections/AboutHeroSection";
import { AboutBeliefsSection } from "@tennr/frontend/sections/AboutBeliefsSection";
import { AboutTeamSection } from "@tennr/frontend/sections/AboutTeamSection";
import { AboutPressSection } from "@tennr/frontend/sections/AboutPressSection";
import { AboutInvestorsSection } from "@tennr/frontend/sections/AboutInvestorsSection";
import { PageBackground } from "@tennr/frontend/components/PageBackground";
import { SiteFooter } from "@tennr/frontend/components/SiteFooter";
import { MetadataTags } from "@tennr/frontend/components/MetadataTags";
import "./AboutPage.css";

const bgImage = "/img/about-us-hero-bg.jpg";
const bgImageVert = "/img/about-us-hero-bg-vert.jpg";

export const AboutPage: React.FC = () => {
  useEffect(() => {
    const preload = (src?: string) => {
      if (!src) return;
      const img = new Image();
      img.src = src;
    };

    const isMobile = window.innerWidth <= 768 || window.matchMedia("(orientation: portrait)").matches;

    if (isMobile) {
      // Preload vertical/mobile images
      preload("/img/homepage-hero-bg-vert2.jpg");
      preload("/img/product-hero-bg-vert2.jpg");
      preload("/img/customer-stories-hero-bg-vert.jpg");
      preload("/img/about-us-hero-bg-vert.jpg");
      preload("/img/case-study-hero-bg-vert.jpg");
      preload("/img/book-demo-hero-bg-vert.jpg");
    } else {
      // Preload desktop images
      preload("/img/homepage-hero-bg.jpg");
      preload("/img/product-hero-bg.jpg");
      preload("/img/customer-stories-hero-bg.jpg");
      preload("/img/about-us-hero-bg.jpg");
      preload("/img/case-study-hero-bg.jpg");
      preload("/img/book-demo-hero-bg.jpg");
    }

    preload("/img/grain.png"); // always used
  }, []);

  return (
    <>
      <MetadataTags
        title="About Us | Tennr"
        description="Meet the team making healthcare move faster."
        imageUrl="https://tennr.com/share_cards/sharecard-about.webp"
      />
      <main className="about-page">
        <PageBackground bgImage={bgImage} bgImageVert={bgImageVert} />
        <AboutHeroSection />
        <AboutInvestorsSection />
        <AboutPressSection />
        <AboutBeliefsSection />
        <AboutTeamSection />
      </main>
      <SiteFooter
        taglineTitle="Take Back Your Time"
        taglineHeading={"Focus on impact,\nnot the inbox."}
        taglineBody={"Your team is your best asset. Keep\nthem focused on what counts."}
        taglinePosition="left"
        bgImage="/img/footer-about-us-bg.jpg"
        bgImageVert="/img/footer-about-us-bg-vert.jpg"
      />
    </>
  );
};
